<template>
  <v-container>
    <h1>
      <v-icon v-if="!isEdited" class="teams-icon" color="lighten-1" medium
        >mdi-plus</v-icon
      ><v-icon v-else class="teams-icon" color="lighten-1" medium
        >mdi-pencil</v-icon
      >
      <span v-if="!isEdited">New Camp Type</span>
      <span v-else>Edit Camp Type</span>
    </h1>
    <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
      <p class="mb-0" v-for="globalErr in globalServerErrors" :key="globalErr">
        {{ globalErr[0] }}
      </p>
    </v-alert>
    <formWrapper :validator="$v.form">
      <form @submit.prevent="handleSave" class="form-box">
        <v-row>
          <v-col md="6" sm="12" cols="12" class="align-self-center">
            <section class="file-upload">
              <new-image-upload
                class="file-upload__image"
                :imgUrl="form.photo ? form.photo.path : ''"
                :imgId="form.photo ? form.photo.id : ''"
                @fileSelected="profileChange"
                fieldName="mainImgFile"
                :maxSize="maxSize"
                :height="320"
                :width="320"
                :reset="resetBoolean"
              />
              <p class="my-2 gray">
                <small
                  >Upload Camp Type Image <br />
                  Should be (320 * 320)</small
                >
              </p>
              <template v-if="form.photo_url != null">
                <a
                  :href="form.photo_url"
                  target="_blank"
                  v-if="isEdited === true && photoBoolean"
                  class="mt-8"
                >
                  show image
                </a>
              </template>
            </section>
          </v-col>
          <v-col md="6" sm="12" cols="12" class="align-self-center">
            <section class="file-upload">
              <new-image-upload
                class="file-upload__image"
                :imgUrl="form.event_1_photo ? form.event_1_photo.path : ''"
                :imgId="form.event_1_photo ? form.event_1_photo.id : ''"
                @fileSelected="photoOneChange"
                fieldName="mainImgFile"
                :height="765"
                :width="1688"
                :maxSize="maxSize"
                :reset="resetOneBoolean"
              />
              <p class="my-2 gray">
                <small
                  >Upload Camp Type Header
                  <br />
                  Should be (1688 * 765)
                </small>
              </p>
              <template v-if="form.event_1_photo_url != null">
                <a
                  :href="form.event_1_photo_url"
                  target="_blank"
                  v-if="isEdited === true && photoOneBoolean"
                  class="mt-8"
                >
                  show image
                </a>
              </template>
            </section>
          </v-col>
          <!-- <v-col sm="12" cols="12" class="align-self-center">
            <section class="file-upload">
              <new-image-upload
                class="file-upload__image"
                :imgUrl="form.event_2_photo ? form.event_2_photo.path : ''"
                :imgId="form.event_2_photo ? form.event_2_photo.id : ''"
                @fileSelected="photoTwoChange"
                fieldName="mainImgFile"
                :maxSize="maxSize"
                :reset="resetTwoBoolean"
              />
              <p class="my-2 gray">
                <small>Upload Photo One</small>
              </p>
              <template v-if="form.event_2_photo_url != null">
                <a
                  :href="form.event_2_photo_url"
                  target="_blank"
                  v-if="isEdited === true && photoTwoBoolean"
                  class="mt-8"
                >
                  show image
                </a>
              </template>
            </section>
          </v-col> -->
          <v-col class="py-2" sm="6" cols="12">
            <form-group name="name" :attribute="`fields.name`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.name"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col class="py-2 mx-auto" cols="12" sm="6">
            <form-group name="title" :attribute="`fields.title`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.title"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col sm="6" cols="12" class="py-0">
            <section class="increment-label">
              <span>Order</span>
              <number-input
                center
                v-model="form.order"
                :min="1"
                :step="1"
                controls
              ></number-input>
            </section>
          </v-col>
          <v-col class="py-0" cols="12" sm="6">
            <form-group name="category" :attribute="`fields.category`">
              <template slot-scope="{ attrs, listeners }">
                <v-select
                  :loading="loadingData"
                  :items="categories"
                  v-bind="attrs"
                  v-on="listeners"
                  item-text="name"
                  item-value="id"
                  regular
                  clearable
                  v-model="form.category"
                ></v-select>
              </template>
            </form-group>
          </v-col>

          <v-col cols="12">
            <form-group name="description" :attribute="`fields.description`">
              <template slot-scope="{ attrs, listeners }">
                <v-textarea
                  label="Description"
                  regular
                  v-bind="attrs"
                  v-on="listeners"
                  v-model.trim="form.description"
                ></v-textarea>
              </template>
            </form-group>
          </v-col>
          <v-col sm="6" class="py-0">
            <section class="transparent-field h-40">
              <v-switch
                class="mt-0"
                :true-value="1"
                :false-value="0"
                v-model="form.can_register"
                label="Open For Registeration"
              ></v-switch>
            </section>
          </v-col>
          <v-col sm="6" class="py-0">
            <section class="transparent-field h-40">
              <v-switch
                class="mt-0"
                :true-value="1"
                :false-value="0"
                v-model="form.on_website"
                label="Appear in website ?"
              ></v-switch>
            </section>
          </v-col>
          <v-col cols="12">
            <v-btn
              class="success text-capitalize mt-8"
              large
              type="submit"
              width="30%"
              :disabled="$v.form.$invalid"
              ><span>Save</span>
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </formWrapper>
  </v-container>
</template>

<script>
import { StoreData, ShowData, UpdateData } from "@/helpers/apiMethods";
import { required, maxLength } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      form: {
        name: "",
        title: "",
        order: "",
        category: "",
        photo: "",
      },
      categories: [
        { id: "IND", name: "Individual" },
        { id: "FAM", name: "Family" },
        { id: "LDR", name: "Leadership" },
        { id: "ABR", name: "ABR" },
      ],
      maxSize: 2.048,
      Photo: false,
      isEdited: false,
      loadingData: false,
      globalServerErrors: null,
      photoBoolean: true,
      resetBoolean: false,
      photoChange: false,
      photoOneBoolean: true,
      resetOneBoolean: false,
      photoOneBooleanChange: false,
      photoTwoBoolean: true,
      resetTwoBoolean: false,
      photoTwoBooleanChange: false,
    };
  },

  created() {
    this.editCreateBoolean();
  },
  methods: {
    handleSave() {
      if (!this.isEdited) {
        this.createLocation();
      } else {
        this.editBusStop();
      }
    },
    editCreateBoolean() {
      if (this.$route.params.id) {
        this.isEdited = true;
      } else {
        this.isEdited = false;
      }
    },
    showData(id) {
      ShowData({
        reqName: `camp-types`,
        id: id,
      })
        .then((res) => {
          const { camp_type } = res.data;
          this.form = camp_type;
        })
        .catch(() => {});
    },
    createLocation() {
      const formData = new FormData();
      Object.keys(this.form).forEach((formItem) => {
        formData.append(formItem, this.form[formItem]);
      });
      StoreData({
        reqName: `camp-types`,
        data: formData,
      })
        .then(() => {
          this.$router.push("/camp-types");
        })
        .catch((err) => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    editBusStop() {
      const formData = new FormData();
      if (!this.photoChange) {
        delete this.form.photo;
      }
      if (!this.photoOneBooleanChange) {
        delete this.form.event_1_photo_url;
      }
      if (!this.photoTwoBooleanChange) {
        delete this.form.event_2_photo_url;
      }
      Object.keys(this.form).forEach((formItem) => {
        if (
          formItem === "photo_url" ||
          formItem === "sub_types" ||
          formItem === "is_family"
        ) {
          return;
        } else {
          if (this.form[formItem] != null) {
            formData.append(formItem, this.form[formItem]);
          }
        }
      });
      formData.append("_method", "put");
      UpdateData({
        reqName: `camp-types`,
        data: formData,
        id: this.$route.params.id,
      })
        .then(() => {
          this.isEdited = false;
          this.$router.push("/camp-types");

          this.reset();
        })
        .catch((err) => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    reset() {
      this.$v.form.$reset();
      this.$store.dispatch("ClearServerErrors");
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    profileChange(photo) {
      this.form.photo = photo.file;
      this.photoBoolean = false;
      this.resetBoolean = false;
      this.photoChange = true;
    },
    photoOneChange(photo) {
      this.form.event_1_photo = photo.file;
      this.photoOneBoolean = false;
      this.resetOneBoolean = false;
      this.photoOneBooleanChange = true;
    },
    photoTwoChange(photo) {
      this.form.event_2_photo = photo.file;
      this.photoTwoBoolean = false;
      this.resetTwoBoolean = false;
      this.photoTwoBooleanChange = true;
    },
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === "campTypeEdit") {
          this.$nextTick(() => {
            this.showData(route.params.id);
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
  validations: {
    form: {
      name: {
        required,
        maxLength: maxLength(255),
      },
      title: {
        required,
        maxLength: maxLength(255),
      },
      category: {
        required,
      },
      description: {
        required,
        maxLength: maxLength(4000),
      },
    },
  },
};
</script>
